var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defaultBody } from '@/shared/functions/maps';
import api from '../axios-api';
import { parseJsonApiResponse } from '@/shared/jsonapiAdapter';
import { parseProject } from '@/types/project.types';
var MODEL = 'Project';
var baseUrl = "/".concat(MODEL, "/");
var list = function (params) { return __awaiter(void 0, void 0, Promise, function () {
    var response, apiResponse, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.get(baseUrl, { params: params })];
            case 1:
                response = _a.sent();
                apiResponse = parseJsonApiResponse(response.data, parseProject);
                return [2 /*return*/, {
                        data: apiResponse.data,
                        pagination: apiResponse.pagination,
                        links: apiResponse.links,
                        meta: apiResponse.meta,
                    }];
            case 2:
                error_1 = _a.sent();
                throw error_1.message;
            case 3: return [2 /*return*/];
        }
    });
}); };
var get = function (id) { return __awaiter(void 0, void 0, Promise, function () {
    var response, apiResponse, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.get("".concat(baseUrl).concat(id, "/"))];
            case 1:
                response = _a.sent();
                apiResponse = parseJsonApiResponse(response.data, parseProject);
                return [2 /*return*/, {
                        data: apiResponse.data,
                        pagination: apiResponse.pagination,
                        links: apiResponse.links,
                        meta: apiResponse.meta,
                    }];
            case 2:
                error_2 = _a.sent();
                throw error_2.message;
            case 3: return [2 /*return*/];
        }
    });
}); };
var create = function (body) { return __awaiter(void 0, void 0, Promise, function () {
    var newBody, response, apiResponse, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newBody = defaultBody({ MODEL: MODEL, body: body, id: undefined });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, api.post(baseUrl, newBody)];
            case 2:
                response = _a.sent();
                apiResponse = parseJsonApiResponse(response.data, parseProject);
                return [2 /*return*/, {
                        data: apiResponse.data,
                        pagination: apiResponse.pagination,
                        links: apiResponse.links,
                        meta: apiResponse.meta,
                    }];
            case 3:
                error_3 = _a.sent();
                throw error_3.message;
            case 4: return [2 /*return*/];
        }
    });
}); };
var update = function (id, body) { return __awaiter(void 0, void 0, Promise, function () {
    var newBody, response, apiResponse, error_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newBody = defaultBody({ MODEL: MODEL, body: body, id: id });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, api.patch("".concat(baseUrl).concat(id, "/"), newBody)];
            case 2:
                response = _a.sent();
                apiResponse = parseJsonApiResponse(response.data, parseProject);
                return [2 /*return*/, {
                        data: apiResponse.data,
                        pagination: apiResponse.pagination,
                        links: apiResponse.links,
                        meta: apiResponse.meta,
                    }];
            case 3:
                error_4 = _a.sent();
                throw error_4.message;
            case 4: return [2 /*return*/];
        }
    });
}); };
var remove = function (id) { return __awaiter(void 0, void 0, Promise, function () {
    var response, error_5;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.delete("".concat(baseUrl).concat(id, "/"))];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
            case 2:
                error_5 = _a.sent();
                throw error_5.message;
            case 3: return [2 /*return*/];
        }
    });
}); };
var iniciarProjeto = function (id) { return __awaiter(void 0, void 0, Promise, function () {
    var response, apiResponse, error_6;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, api.post("".concat(baseUrl).concat(id, "/iniciar-projeto/"))];
            case 1:
                response = _a.sent();
                apiResponse = parseJsonApiResponse(response.data, parseProject);
                return [2 /*return*/, {
                        data: apiResponse.data,
                        pagination: apiResponse.pagination,
                        links: apiResponse.links,
                        meta: apiResponse.meta,
                    }];
            case 2:
                error_6 = _a.sent();
                throw error_6.message;
            case 3: return [2 /*return*/];
        }
    });
}); };
export default {
    list: list,
    create: create,
    get: get,
    update: update,
    remove: remove,
    iniciarProjeto: iniciarProjeto,
};
